.subtitle {
  color: var(--gray-600);
}
